export default __webpack_public_path__ + "static/media/MBTorpedo.697b6f1d.png";